import React from 'react';
import { Button, Dialog } from '@ftdr/blueprint-components-react';
import { generateCsv, download, ConfigOptions, mkConfig } from 'export-to-csv';
import { getCurrentThemeConfig } from '@app/core/theme-config';

interface ExportCsvProps {
  id: string;
  header: string;
  body: React.ReactElement | null;
  csvData: { [key:string]: string }[];
  isOpen: boolean;
  onClose: () => void;
  fileName: string;
}
const ExportCsv: React.FC<ExportCsvProps> = ({
                                              ...props
                                            }) => {


  const generateCSV = () => {
    const config = mkConfig({
      useKeysAsHeaders: true,
      filename: props.fileName,
    })
    const csv = generateCsv(config)(props.csvData);
    download(config)(csv)
  }

  return (
    <>
      <Dialog
        id={props.id}
        header={props.header}
        modal={true}
        onClose={props.onClose}
        open={props.isOpen}
        actionsAlign="right"
        actions={[
          <Button
            key="action"
            className={getCurrentThemeConfig().modalStyleButton}
            color={getCurrentThemeConfig().modalOkStyleButtonColor}
            size="medium"
            label="Download"
            onClick={() => {
              generateCSV();
              props.onClose()}}
          />,
          <Button
            key="cancel"
            className={getCurrentThemeConfig().modalStyleButton}
            size="medium"
            label="Cancel"
            onClick={props.onClose}
          />,
        ]}
      >
        {props.body}
      </Dialog>
    </>
  );
};

export default ExportCsv;
